// app/community/community.js

(function () {
    'use strict';
    var controllerId = 'community';
    angular.module('app').controller(controllerId, ['common', '$rootScope', 'datacontext', 'bootstrap.dialog', "$uibModal", 'sectionMenu', '$translate', communityFn]);

    function communityFn(common, $rootScope, datacontext, bDialog, $uibModal, sectionMenu, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = 'Community'
        vm.filter = '';
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.getDocenti = getDocenti;
        vm.showDocente = showDocente;
        vm.showRichiesta = showRichiesta;
        vm.showAllAmici = showAllAmici;
        vm.showAllRichieste = showAllRichieste;
        vm.attivaCommunity = attivaCommunity;
        vm.annullaCommunity = annullaCommunity;
        vm.showRichiesteRifiutate = showRichiesteRifiutate;
        vm.changeImage = changeImage;

        vm.currentLanguage = $translate.proposedLanguage() || $translate.use();

        //List
        vm.list = {}
        vm.list.amici = [];
        vm.list.amiciTopSix = [];
        vm.amiciCount = 0;
        vm.amiciTopSixCount = 0;
        vm.testAmiciCount = 0;
        vm.list.richieste = [];
        vm.list.richiesteTopSix = [];
        vm.richiesteCount = 0;
        vm.richiesteTopSixCount = 0;
        vm.list.richiesteRifiutate = [];
        vm.richiesteRifiutateCount = 0;
        vm.profilo = {};

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId).then(function () {
                if ($rootScope.community == true) {
                    getProfilo();
                    getListAmici();
                    getListRichieste();
                    getListRichiesteRifiutate();
                    aggiornaConteggioRichiestePendenti();
                }                
            });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function getProfilo() {
            datacontext.community_getProfilo().then(function (data) {
                datacontext.materia_getAllByDocenteId($rootScope.id).then(function (materie) {
                    datacontext.classe_getAllByDocenteId($rootScope.id).then(function (classi) {
                        vm.profilo.classi = _.uniq(classi, 'Grado');
                    });
                    vm.profilo.materie = materie;
                });
                return vm.profilo = data;                
            });
        }

        function getDocenti(filter) {            
            return datacontext.community_ricercaDocenti(filter).then(function (data) {                
                return data;
            });
        }

        function getListAmici() {            
            vm.list.amici = [];
            vm.list.amiciTopSix = [];
            vm.amiciCount = 0;
            vm.amiciTopSixCount = 0;
            vm.testAmiciCount = 0;

            return datacontext.community_getAllAmici().then(function (data) {                
                vm.amiciCount = data.length;
                vm.list.amici = data;                
                
                vm.amiciTopSixCount = data.length >= 5 ? 5 : data.length;

                for (var i = 0; i < vm.amiciTopSixCount; i++) {
                    vm.list.amiciTopSix.push(data[i]);
                }

                //Conteggio test amici
                for (var k = 0; k < data.length; k++) {
                    if (data[k].stat_numTest)
                        vm.testAmiciCount += data[k].stat_numTest;
                }

                return vm.list.amiciTopSix;
            });
        }

        function getListRichieste() {
            vm.list.richieste = [];
            vm.list.richiesteTopSix = [];
            vm.richiesteCount = 0;
            vm.richiesteTopSixCount = 0;

            return datacontext.community_getAllRichieste(-1).then(function (data) {                
                vm.richiesteCount = data.length;
                vm.list.richieste = data;
                
                vm.richiesteTopSixCount = data.length >= 5 ? 5 : data.length;

                for (var i = 0; i < vm.richiesteTopSixCount; i++) {
                    vm.list.richiesteTopSix.push(data[i]);
                }
                return vm.list.richiesteTopSix;
            });
        }

        function getListRichiesteRifiutate() {
            return datacontext.community_getAllRichiesteRifiutate().then(function (data) {                                
                vm.richiesteRifiutateCount = data.length;
                return vm.list.richiesteRifiutate = data;
            });
        }        

        function aggiornaConteggioRichiestePendenti() {
            $rootScope.richiesteCount = 0;
            datacontext.community_getAllRichieste(0).then(function (data) {
                $rootScope.richiesteCount = data.length;
            });
        }

        //Modal
        function showDocente(item) {
            vm.filter = '';
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/community/modal/profiloDocente.html?version=43",
                controller: "profiloDocente",
                resolve: {
                    docente: function () {
                        return item;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                vm.listAmici = getListAmici();
                vm.listRichieste = getListRichieste();
            });
        }

        function showRichiesta(item) {            
            var docente = {};
            if (item.DestId == $rootScope.id) {
                docente.Id = item.MittId;
                docente.Nome = item.Mitt;
                docente.Citta = item.MittCitta;
                docente.Istituto = item.MittIstituto;
                docente.Materia = item.MittMateria;
                docente.stat_numTest = item.MittTest;
                docente.stat_numSessioni = item.MittSessioni;
                docente.Sesso = item.MittSesso;
                docente.Icona = item.MittIcona;                
            }
            else if (item.MittId == $rootScope.id) {
                docente.Id = item.DestId;
                docente.Nome = item.Dest;
                docente.Citta = item.DestCitta;
                docente.Istituto = item.DestIstituto;
                docente.Materia = item.DestMateria;
                docente.stat_numTest = item.DestTest;
                docente.stat_numSessioni = item.DestSessioni;
                docente.Sesso = item.DestSesso;
                docente.Icona = item.DestIcona;
            }        
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/community/modal/profiloDocente.html?version=43",
                controller: "profiloDocente",
                resolve: {
                    docente: function () {
                        return docente;
                    }
                }
            });

            modalInstance.result.then(function () {
                vm.listAmici = getListAmici();
                vm.listRichieste = getListRichieste();
                vm.listRichiesteRifiutate = getListRichiesteRifiutate();
            });
        }

        function showAllAmici() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/community/modal/elencoAmici.html?version=43",
                controller: "elencoAmici",
                resolve: {
                    amici: function () {
                        return vm.list.amici;
                    }
                }
            });

            modalInstance.result.then(function () {
                vm.listAmici = getListAmici();
                vm.listRichieste = getListRichieste();
            });
        }

        function showAllRichieste() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/community/modal/elencoRichieste.html?version=43",
                controller: "elencoRichieste",
                resolve: {
                    richieste: function () {
                        return vm.list.richieste;
                    }
                }
            });

            modalInstance.result.then(function () {
                vm.listAmici = getListAmici();
                vm.listRichieste = getListRichieste();
                vm.richiesteRifiutate = getListRichiesteRifiutate();
            });
        }

        function showRichiesteRifiutate() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/community/modal/elencoRichieste.html?version=43",
                controller: "elencoRichieste",
                resolve: {
                    richieste: function () {
                        return vm.list.richiesteRifiutate;
                    }
                }
            });

            modalInstance.result.then(function () {
                vm.listAmici = getListAmici();
                vm.listRichieste = getListRichieste();
                vm.richiesteRifiutate = getListRichiesteRifiutate();
            });
        }

        function attivaCommunity() {
            datacontext.community_attiva().then(function (data) {
                if (!data || !data.Id || data.Id == 0) {
                    logError($translate.instant('OperazioneNonRiuscita'));
                    return;
                }

                logSuccess($translate.instant('Benvenuto') + ' community Siverapp!');
                $rootScope.community = data.Community;
                $rootScope.dataCommunity = data.DataCommunity;

                $rootScope.richiesteCount = 0;
                datacontext.community_getAllRichieste(0).then(function (data) {
                    $rootScope.richiesteCount = data.length;
                });

                getProfilo();
                getListAmici();
                getListRichieste();
                getListRichiesteRifiutate();
            });
        }

        function annullaCommunity() {
            var msg = $translate.instant('AvvisoAnnullareIscrizione');
            bDialog.confirmationDialog($translate.instant('Conferma'), msg).then(function () {
                datacontext.community_annulla().then(function (data) {
                    if (!data || !data.Id || data.Id == 0) {
                        logError($translate.instant('OperazioneNonRiuscita'));
                        return;
                    }

                    $rootScope.community = data.Community;
                    $rootScope.dataCommunity = data.DataCommunity;

                    $rootScope.richiesteCount = 0;
                    datacontext.community_getAllRichieste(0).then(function (data) {
                        $rootScope.richiesteCount = data.length;
                    });

                    logSuccess($translate.instant('IscrizioneAnnullata'));
                });
            });
        }

        function changeImage() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/community/modal/profiloImage.html?version=43",
                controller: "profiloImage",
                resolve: {
                    profilo: function () { return vm.profilo; }
                }
            });

            modalInstance.result.then(function (returnItem) {
                logSuccess($translate.instant('ProfiloSalvato'));
                vm.profilo.Icona = returnItem;
            });
        }
    }
})();
